<template>
    <div class="vue-sidebar-item">
        <a v-bind:href="url" v-bind:class="styles">
            <span class="inline-block w-8 text-xl text-gray-300 mr-3 flex-shrink-0">
                <span v-bind:class="icon"></span>
            </span>
            <span v-if="label" class="flex-1" v-text="label"></span>
            <span v-if="notifications" class="bg-gray-900 group-hover:bg-gray-800 ml-3 inline-block py-0.5 px-3 text-xs font-medium rounded-full" v-text="notifications"></span>
        </a>
    </div>
</template>

<script>
    export default {
        props: ['label', 'url', 'icon', 'active', 'notifications'],
        data: function() {
            return { };
        },
        mounted: function() {
            //
        },
        computed: {
            styles() {
                return (this.active)
                    ? 'group flex items-center px-2 py-2 text-sm font-medium rounded-md bg-gray-900 text-white'
                    : 'group flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-300 hover:bg-gray-700 hover:text-white';
            },
        },
        methods: {
            //
        }
    }
</script>
